import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import { Helmet } from 'react-helmet-async';


function Recognition() {
  return (
    <div >
      <Helmet>
        <title>Recognition | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about the Recognition process at the State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Recognition</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container'>
          <div className="content-secion">
            <ol className="text">
              <li>As per Administrative Recognized under “MINDS” Regd. by <strong>Govt. of India, NCT</strong> Govt. of Delhi Vide letter No. SBSE/G2/GF-04/14 New Delhi .</li>
              <li>Accredited by <strong>International</strong> Accreditation Organization, (IAO),USA</li>
              <li>Chief Notary and Authentication Section of the District of Columbia (USA)</li>
              <li>State Board of Secondary Education ,Delhi, IAO Certified Authentication issued by the Department of State Government of United State of America .</li>
              <li>Certified Full faith and Credited from USA State of Columbia.</li>
              <li>Authenticated Certified of Department at the City of Washington in the district of Columbia.(USA)</li>
              <li>Issued pursuant to CHXI State of Sept.15.1789,1 state 68-69,22USC 2657,22USC,2651a: 5USC301:28USC1733 et seq:8USC1443(f): RULE 44 Federal Rules of Civil Procedure.</li>
              <li>Authorize Signatory of SBSE Delhi all whom these Presents Shall come Greetings issued &amp; Certified by Washington, D.C Ousama Fatima.</li>
              <li>Grant of Membership of COBSE, Letter issued date 29 May 2014 shortly shall be recognized.</li>
              <li>We clarify that all the Educational Institutions (Boards, Councils or Universities) are Autonomous Bodies and it is left to their discretion to allow or refuse admission to those comming from other Universities, Colleges or Institutions etc.</li>
              <li>Accordingly State Board Of Secondary Education Delhi, also Recognized by Ministry of Human Resource and Development Government of India , HRD Minister Mr. Madhav Rao Scindhia who had introduced Private Universities bill for the first in the parliament in 1995.and since then the Board has marched ahead covering a long distance till what it is today on its own footing/running.</li>
              <li>Student passing the courses conducted by State Board of Secondary Education, Delhi, are Getting <strong>Employment &amp; Admission</strong> in the University’s Recognized by <strong>UGC,</strong> Educational <strong>Board’s, Councils </strong>and in Other Recognized <strong>institutions.</strong></li>
              <li>According to National Educational Policy 1986 of Govt. of India State Board of Secondary Education, Delhi is one of the best institution for speeding as Regular ,<strong>Distance</strong> and <strong>Correspondence</strong> education under <strong>open Education Program system</strong>.</li>
              <li>According to Hon’ble Supreme Court 2178(I) Under Write Petition No AIR/1993 to J. P. Unnikrishan Vs Govt. of Andhra Pradesh voluntary institute have a Right to spread education and issue Certificate / Diploma ..</li>
              <li>Secondary and Senior Secondary Courses Should be equivalent of Metric and Intermediate (10th and 10+2 Standard).</li>
              <li>The matter is under Active Consideration by different state’s Government in India</li>
              <li>The Secondary is equivalent to Metric ( 10th ) and Sr. Secondary is equivalent to Intermediate. courses vide Government Notification No. 2342/E/90 dated 12/0 The Board is inspired Distance Educational council system (DEC) New Delhi.</li>
              <li>The Board is Process TR. successfully on all frontiers and are able the excel as man of eminence by securing higher position in life. The Certified.</li>
              <li>The Board is under Process to obtain Accreditation Certificate of NIOS &amp; CBSE.</li>
              <li>State Board of Secondary Education Delhi, has been assessed by SGC,</li>
              <li>ISO 9001:2008 Certified.</li>
              <li>Eligibility standards CHEA according by IAO &amp; ISO..</li>
            </ol>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Recognition;
